import { Injectable, inject } from '@angular/core';
import { User } from 'firebase/auth';
import { addDoc, serverTimestamp } from 'firebase/firestore';
import { FirebaseService } from '../../data/firebase.service';
import { ENEZA_RESELLER_FIRESTORE_PATHS } from './firestore-paths';
import { FloatHistory, SmsCreditsHistory } from './float.history.model';

@Injectable({
  providedIn: 'root',
})
export class ResellerHistoryService {
  private fbService = inject(FirebaseService);
  private paths = inject(ENEZA_RESELLER_FIRESTORE_PATHS);

  addClientHistoryItem = async (adminUser: User, clientId: string, changes: any) => {
    changes.doneBy = adminUser?.uid;
    changes.doneByEmail = adminUser?.email;
    changes.actionDate = serverTimestamp();

    const colRef = this.fbService.getColRef(
      `${this.paths.FB_CLIENTS}/${clientId}/${this.paths.FB_HISTORY_SUB_ITEMS}`,
    );
    await addDoc(colRef, changes);
  };

  addCustomClientHistoryItem = async (
    adminUser: User,
    clientId: string,
    changes: any,
    historyCode: string,
  ) => {
    changes.doneBy = adminUser?.uid;
    changes.doneByEmail = adminUser?.email;
    changes.actionDate = serverTimestamp();
    changes.historyCode = historyCode;

    const colRef = this.fbService.getColRef(
      `${this.paths.FB_CLIENTS}/${clientId}/${this.paths.FB_HISTORY_SUB_ITEMS}`,
    );
    await addDoc(colRef, changes);
  };

  addCustomResellerHistoryItem = async (
    adminUser: User,
    resellerId: string,
    changes: any,
    historyCode: string,
  ) => {
    changes.doneBy = adminUser?.uid;
    changes.doneByEmail = adminUser?.email;
    changes.actionDate = serverTimestamp();
    changes.historyCode = historyCode;

    const colRef = this.fbService.getColRef(
      `${this.paths.FB_RESELLERS}/${resellerId}/${this.paths.FB_HISTORY_SUB_ITEMS}`,
    );
    await addDoc(colRef, changes);
  };

  addClientFloatHistory = async (adminUser: User, clientId: string, changes: FloatHistory) => {
    changes.doneBy = adminUser?.uid;
    changes.doneByEmail = adminUser?.email;
    changes.type = changes.amount < 0 ? 'debit' : 'credit';
    changes.actionDate = serverTimestamp();

    const colRef = this.fbService.getColRef(
      `${this.paths.FB_CLIENTS}/${clientId}/${this.paths.FB_FLOAT_HISTORY}`,
    );
    await addDoc(colRef, changes);
  };

  addClientSmsCreditsHistory = async (
    adminUser: User,
    clientId: string,
    changes: SmsCreditsHistory,
  ) => {
    changes.doneBy = adminUser?.uid;
    changes.doneByEmail = adminUser?.email;
    changes.type = changes.credits < 0 ? 'debit' : 'credit';
    changes.actionDate = serverTimestamp();

    // TODO: use a dedicated SMS credits history collection when available
    const colRef = this.fbService.getColRef(
      `${this.paths.FB_CLIENTS}/${clientId}/${this.paths.FB_FLOAT_HISTORY}`,
    );
    await addDoc(colRef, changes);
  };

  addResellerFloatHistory = async (adminUser: User, resellerId: string, changes: FloatHistory) => {
    changes.doneBy = adminUser?.uid;
    changes.doneByEmail = adminUser?.email;
    changes.type = changes.amount < 0 ? 'debit' : 'credit';
    changes.actionDate = serverTimestamp();

    const colRef = this.fbService.getColRef(
      `${this.paths.FB_RESELLERS}/${resellerId}/${this.paths.FB_FLOAT_HISTORY}`,
    );
    await addDoc(colRef, changes);
  };

  addResellerSMSCreditsHistory = async (
    adminUser: User,
    resellerId: string,
    changes: SmsCreditsHistory,
  ) => {
    changes.doneBy = adminUser?.uid;
    changes.doneByEmail = adminUser?.email;
    changes.type = changes.amount < 0 ? 'debit' : 'credit';
    changes.actionDate = serverTimestamp();

    const colRef = this.fbService.getColRef(
      `${this.paths.FB_RESELLERS}/${resellerId}/${this.paths.FB_FLOAT_HISTORY}`,
    );
    await addDoc(colRef, changes);
  };
}
